/*
Address Data
*/

import React, { useEffect, useState } from "react";
import ConditionLabel from "../../../../components/calculator/ConditionLabel/ConditionLabel";
import AdatokItem from "./AdatokItem";
import BackButton from "../../../../components/calculator/ConditionLabel/BackButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constants/Routes";
import ArrowLeft from ".//..//..//..//..//assets//images//icons//arrow-left.svg";
import StepBar from "../../../../components/calculator/Wizard/StepBar";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import useAuth from "../../../../hooks/useAuth";
import { toast } from "react-toastify";
import Spinner from "../../../../components/common/Splnner/Spinner";

const KalkulacioAdatok = () => {
  const [step, setStep] = useState(3);
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const [proposalKey, setProposalKey] = useState("");
  const { getAuth, clearAuth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const proposalId = searchParams.get("p-id");

  const [activeTab, setActiveTab] = useState(0);

  const activeTabHandler = (tabNo) => {
    setActiveTab(tabNo);
  };

  const [destinations, setDestinations] = useState([]);

  function makeid(length) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const fetchTourPlan = () => {
    setSpinnerVisible(true);
    HttpHelper.GetRequest({
      route: `${API_ROUTES.PR_TOURPLAN_LIST}?proposal_id=${proposalId}`,
      token: getAuth()?.bearerToken,
    })
      .then((data) => {
        if (data.status == 200) {
          const proposalTourPlan = data?.data?.proposalTourPlan;
          const proposalData = data?.data?.proposalData;
          setProposalKey(proposalData[0]?.proposal_number);
          const arr = [];
          proposalTourPlan.forEach((item, index) => {
            const id = item?.id;
            const streetNumber = item?.streetNumber;
            const route = item?.route;
            const country = item?.country;
            const locality = item?.locality;
            const postalCode = item?.postalCode;
            const place_id = item?.place_id;
            const helyszin_neve = item?.helyszin_neve;
            const cim = item?.cim;
            const latitude = item?.latitude;
            const longitute = item?.longitute;
            const emelet = item?.emelet;
            const tavolsag = item?.tavolsag;
            const megallo = item?.megallo;
            const lift = item?.lift;
            const szuk_lepcsohaz = item?.szuk_lepcsohaz;
            const kozteruleti_ugyintezes = item?.kozteruleti_ugyintezes;
            const note = item?.note;
            const uniqueId = `${Date.now()}${makeid(5)}`;
            arr.push({
              id,
              streetNumber,
              route,
              country,
              locality,
              postalCode,
              place_id,
              helyszin_neve,
              cim,
              latitude,
              longitute,
              emelet,
              tavolsag,
              megallo,
              lift,
              szuk_lepcsohaz,
              kozteruleti_ugyintezes,
              note,
              uniqueId,
            });
          });
          setSpinnerVisible(false);
          setDestinations(arr);
        } else if (data.status == 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else if (data.status == 500) {
          toast.error("Error, Server Error !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        } else {
          toast.error("Unknown server error 1!", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSpinnerVisible(false);
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Unknown server error 2!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setSpinnerVisible(false);
      });
  };

  useEffect(() => {
    fetchTourPlan();
  }, []);

  const updateDesitinationByPlaceId = (uniqueId, updatedFields) => {
    setDestinations((prevArray) =>
      prevArray.map((item) => {
        if (item.uniqueId === uniqueId) {
          return {
            ...item,
            ...updatedFields,
          };
        }
        return item;
      })
    );
  };

  const updateChanges = (
    emelet,
    tavolsag,
    megallo,
    lift,
    szuk_lepcsohaz,
    kozteruleti_ugyintezes,
    note,
    place_id,
    uniqueId
  ) => {
    const IdToUpdate = uniqueId;
    const updateFields = {
      emelet,
      tavolsag,
      megallo,
      lift,
      szuk_lepcsohaz,
      kozteruleti_ugyintezes,
      note,
    };

    updateDesitinationByPlaceId(IdToUpdate, updateFields);
  };

  const saveTourPlanInformations = () => {
    setSpinnerVisible(true);
    HttpHelper.PostRequest({
      route: API_ROUTES.PR_TOURPLAN_INFORMATION_UPDATE,
      token: getAuth()?.bearerToken,
      parameters: {
        proposal_id: proposalId,
        places: destinations,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          // reset();
          setSpinnerVisible(false);
          // refreshCustomerList();
          toast.success("Útvonalterv információ sikeresen frissítve", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate(`${ROUTES.CAL_MANAGE_ITEM_LIST}?p-id=${proposalId}`);
        } else if (res.status === 422) {
          const messages = res.message;
          console.log(messages);
          setSpinnerVisible(false);
          toast.error("Hiba, az útvonalterv információja nem frissült", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          setSpinnerVisible(false);
          navigator(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        console.log(error);
        setSpinnerVisible(false);
        toast.error("Hiba, az útvonalterv információja nem frissült", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  return (
    <>
      <Spinner spinnerVisible={spinnerVisible}>
        {/* Header Start */}
        <div className="px-[1rem]  sm:px-[1.875rem] mt-[3rem] gap-3 grid grid-cols-2 md:grid-cols-[10rem_1fr_10rem] grid-rows-2 md:grid-rows-1">
          <div className="col-start-1 col-end-2 row-start-2 row-end-3 md:row-span-1 md:row-end-2 ">
            <div className="max-w-[10rem] me-auto">
              <Link to={`${ROUTES.CAL_MANAGE_TOUR_PLAN}?p-id=${proposalId}`}>
                <BackButton icon={ArrowLeft} label={"Vissza"} />
              </Link>
            </div>
          </div>
          <div className="w-full col-span-2 md:col-span-1 md:col-end-3 md:col-start-2 ">
            <StepBar currentStepNo={step} />
          </div>
          <div className="col-start-2 col-end-3 row-start-2 row-end-3 md:col-end-4 md:col-start-3 md:row-span-1 md:row-end-2 ">
            <div className="max-w-[10rem] ms-auto">
              {/* <Link to={ROUTES.CAL_MANAGE_ITEM_LIST}> */}
              <ButtonFluid label={"Mentés"} onClick={saveTourPlanInformations} />
              {/* </Link> */}
            </div>
          </div>
        </div>
        {/* Header End */}
        <div className="px-[1rem] sm:px-[1.875rem] mt-[3.7rem] flex flex-col sm:items-center justify-between sm:flex-row gap-10">
          <div className="flex flex-row items-center gap-[1.5rem]">
            <div className="flex flex-col">
              <span className="text-text-primary-color font-lato text-[1.3rem] md:text-[2rem] font-bold leading-[2.5rem]">
                Ajánlat száma: {proposalKey}
              </span>
            </div>
          </div>
        </div>
        <div className="mx-[1rem]  mt-[3.7rem] gap-10  overflow-x-auto">
          <div className="flex flex-row gap-5 pb-4 sm:items-center">
            {destinations.slice(1).map((destination, index) => {
              return (
                <AdatokItem
                  key={index}
                  updateChanges={updateChanges}
                  destination={destination}
                  tabNo={index}
                  activeTab={activeTab}
                  setActiveTab={activeTabHandler}
                />
              );
            })}
          </div>
        </div>
      </Spinner>
    </>
  );
};

export default KalkulacioAdatok;
